// extracted by mini-css-extract-plugin
module.exports = {"root":"root--b2Jmv"};